import { render, staticRenderFns } from "./SetWaktu.vue?vue&type=template&id=4609134e&"
import script from "./SetWaktu.vue?vue&type=script&lang=js&"
export * from "./SetWaktu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports